export default "__VITE_ASSET__D0fSOA2A__"